const setOrderService = (state, payload) => {
  state.orderService = payload;
};

export default {
  setOrderService,
};
